import React from 'react';

import { useInfinityScroll } from '@hook/useInfinityScroll';
import { sendProductSuggestionBlockClick } from '@utils/analytics';
import { ProductCard, Product } from '@components/ProductCard';
import { Grid, GridProps } from '@components/Grid';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';

// styles
import s from './IndexSuggestionItemsBlock.sss';

export type IndexSuggestionItemsBlockGridProps = Pick<GridProps, 'def' | 'tablet' | 'desktop'>;

type IndexSuggestionItemsBlockProps = {
  products: Product[];
  loading?: boolean;
  hasNextPage: boolean;
  maxCount?: number,
  grid?: IndexSuggestionItemsBlockGridProps,
  onLoadMore(): void;
  onProductClick?: () => void,
};

export const IndexSuggestionItemsBlock: React.FC<IndexSuggestionItemsBlockProps> = ({
  products,
  loading = false,
  hasNextPage,
  maxCount,
  grid = {
    def: 6,
    tablet: 4,
    desktop: '2_4',
  },
  onLoadMore,
  onProductClick,
}) => {
  const scrollRef = useInfinityScroll(onLoadMore, 1000);

  return (
    <div className={s.root}>
      <div className={s.productsWrapper} ref={scrollRef}>
        {
          (loading && !products.length)
            ? (
              <ProductsFeedSleketon
                count={maxCount || 30}
                grid={grid}
              />
            ) : (
              <>
                <Grid container={true} spacing={10}>
                  {
                    products.map((product, k) => (
                      <Grid
                        key={product.id}
                        {...grid}
                      >
                        <ProductCard
                          {...product}
                          onProductClick={() => {
                            sendProductSuggestionBlockClick(k + 1, product.id);
                            if (onProductClick) {
                              onProductClick();
                            }
                          }}
                        />
                      </Grid>
                    ))
                  }
                </Grid>
                {hasNextPage && (
                  <ProductsFeedSleketon
                    count={5}
                    grid={grid}
                  />
                )}
              </>
            )
        }
      </div>
    </div>
  );
};
